import {setExecutorWebAccessToken} from '@rocket-ui/lk-api';
import {setAccessToken} from '@rocket-ui/tsp-client';
import {atom, Getter, Setter} from 'jotai';
import {atomEffect} from 'jotai-effect';
import {tokenAtom} from './authAtom';

export const tokenIsSetAtom = atom<boolean>(false);

export const axiosInterceptorAuthHeaderEffect = atomEffect((get: Getter, set: Setter) => {
	const token = get(tokenAtom);

	if (token === null) return;

	const unsubscribe = setAccessToken(token.token);
	setExecutorWebAccessToken(token.token);
	set(tokenIsSetAtom, true);

	return () => {
		unsubscribe();
		setExecutorWebAccessToken('');
		set(tokenIsSetAtom, false);
	};
});
